export default __webpack_public_path__ + "static/media/email.42ce0921.png";